import styled from 'styled-components';

import { TabSwitcher } from '@tillersystems/stardust';

export const TabHeader = styled(TabSwitcher.Tabs)`
  margin-bottom: 1.5rem;
`;
